export default {"src":"/_next/static/media/arrowForward.388fa461.svg","height":26,"width":26};